import React, { useEffect } from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import Select from 'react-select';
import { getFournisseurs } from 'data/fournisseus';
import PropTypes from 'prop-types';

const DetailsFournisseur = ({ setFournisseur, fournisseur }) => {
  const [dataFounrisseur, setDataFounrisseur] = React.useState([]);
  // const id = fournisseur ? fournisseur.value : null;

  useEffect(() => {
    const fetchFournisseurs = async () => {
      const response = await getFournisseurs();
      console.log('produitsFetched : ', response);
      setDataFounrisseur(
        response.map(fournisseur => ({
          value: fournisseur.id,
          label: fournisseur.societe,
          adresses: fournisseur.adresses
            ? fournisseur.adresses.split(',')[0].replace('[', '')
            : '',
          telephone: fournisseur.telephones
            ? fournisseur.telephones.split(',')[0].replace('[', '')
            : '',
          identificationFiscale: fournisseur.identificationFiscale || '',
          siteWeb: fournisseur.siteWeb || '',
          civilite: fournisseur.civilite
            ? fournisseur.civilite == 1
              ? 'Monsieur'
              : 'Madame'
            : '',
          nomResponsable: fournisseur.nomResponsable || '',
          emailResponsable: fournisseur.emailResponsable || ''
        }))
      );
    };
    fetchFournisseurs();
  }, []);

  return (
    <Card className="mb-4">
      <Card.Body>
        <Card.Title style={{ borderTop: '5px solid blue' }} className="pt-2">
          <div className="d-flex justify-content-between align-items-center">
            <h5>Details Fournisseur</h5>
            <Select
              options={dataFounrisseur}
              placeholder="Select..."
              classNamePrefix="react-select"
              className="w-50 fw-normal fs-9"
              value={fournisseur}
              onChange={value => setFournisseur(value)}
            />
          </div>
        </Card.Title>
        <Card.Body>
          <Row style={{ borderBottom: '1px solid #e0e0e0' }}>
            <Col>
              <h6>Code :</h6>
            </Col>
            <Col className="text-end">
              <h6>{fournisseur?.value || ''}</h6>
            </Col>
          </Row>
          <Row className="mt-2" style={{ borderBottom: '1px solid #e0e0e0' }}>
            <Col>
              <h6>Entreprise :</h6>
            </Col>
            <Col className="text-end">
              <h6>{fournisseur?.label || ''}</h6>
            </Col>
          </Row>
          <Row className="mt-2" style={{ borderBottom: '1px solid #e0e0e0' }}>
            <Col>
              <h6>Adresse :</h6>
            </Col>
            <Col className="text-end">
              <h6>{fournisseur?.adresses || ''}</h6>
            </Col>
          </Row>
          <Row className="mt-2" style={{ borderBottom: '1px solid #e0e0e0' }}>
            <Col>
              <h6>Numéro d'identification fiscale : </h6>
            </Col>
            <Col className="d-flex align-items-center justify-content-end">
              <h6>{fournisseur?.identificationFiscale || ''}</h6>
            </Col>
          </Row>
          <Row className="mt-2" style={{ borderBottom: '1px solid #e0e0e0' }}>
            <Col>
              <h6>Telephone :</h6>
            </Col>
            <Col className="text-end">
              <h6>{fournisseur?.telephone || ''}</h6>
            </Col>
          </Row>
          <Row className="mt-2">
            <Col>
              <h6>Email :</h6>
            </Col>
            <Col className="text-end">
              <h6>{fournisseur?.emailResponsable || ''}</h6>
            </Col>
          </Row>
        </Card.Body>
      </Card.Body>
    </Card>
  );
};

DetailsFournisseur.propTypes = {
  setFournisseur: PropTypes.func.isRequired,
  fournisseur: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.string,
    adresses: PropTypes.string,
    telephones: PropTypes.string,
    telephone: PropTypes.string,
    identificationFiscale: PropTypes.string,
    siteWeb: PropTypes.string,
    civilite: PropTypes.string,
    nomResponsable: PropTypes.string,
    emailResponsable: PropTypes.string,
    code: PropTypes.string,
    societe: PropTypes.string,
    id: PropTypes.number
  })
};

export default DetailsFournisseur;
